var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivityDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6686_510217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6686_510217)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 19.1176C33 19.1864 32.9994 19.2551 32.9981 19.3236H33C33 31.0588 21.9999 36 21.9999 36C21.9999 36 11 31.0588 11 19.3236H11.0018C11.0006 19.2551 11 19.1864 11 19.1176C11 12.9775 15.9249 8 22 8C28.0751 8 33 12.9775 33 19.1176ZM22 26.9412C26.2751 26.9412 29.7407 23.4385 29.7407 19.1177C29.7407 14.7969 26.2751 11.2942 22 11.2942C17.7249 11.2942 14.2593 14.7969 14.2593 19.1177C14.2593 23.4385 17.7249 26.9412 22 26.9412Z",
    fill: "#3B3B3B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivityDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/activity-default.29935eaf75407bf585d9a385ebf7f792.svg";